export const NotificationTypes = {
  Success: "Success",
  Error: "Error",
  Notification: "Notification"
};
